import React, { useEffect, useRef } from "react";
import { Hooks } from "@xt/xtbase";
import styles from "./favMenu.module.less";

const { useTranslation } = Hooks;

/**
 * Favourite 有数据时的长按弹出菜单：Top / Remove from Favorites / Edit Favorites
 * 固定尺寸：宽 270px 高 53px，深色 #36373E 背景。
 */
const MarketListFavMenu = ({ position, onClose, onTop, onRemove, onEdit, editLabel }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) onClose && onClose();
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose && onClose();
    };
    document.addEventListener("mousedown", handleDocClick);
    document.addEventListener("touchstart", handleDocClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleDocClick);
      document.removeEventListener("touchstart", handleDocClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const t = useTranslation();

  const style = {};
  if (position) {
    style.left = `${position.x}px`;
    style.top = `${position.y}px`;
  }

  return (
    <div ref={ref} className={styles.menu} style={style} role="menu">
      <button
        type="button"
        className={styles.item}
        onClick={(e) => {
          e.stopPropagation();
          onTop && onTop();
          onClose && onClose();
        }}
      >
        {t("market.favTop")}
      </button>
      <span className={styles.divider} />
      <button
        type="button"
        className={styles.item}
        onClick={(e) => {
          e.stopPropagation();
          onRemove && onRemove();
          onClose && onClose();
        }}
      >
        {t("market.favRemove")}
      </button>
      <span className={styles.divider} />
      <button
        type="button"
        className={styles.item}
        onClick={(e) => {
          e.stopPropagation();
          onEdit && onEdit();
          onClose && onClose();
        }}
      >
        {editLabel || t("market.favEdit")}
      </button>
    </div>
  );
};

export default MarketListFavMenu;
